// Routes have moved into App and ClientSectionContainer.
export const BOUNDARIES = {
  ACCOUNT: "account",
  SETTINGS: "settings",
  SHOP: "shop",
  CART: "cart"
};
